<template>
  <v-container>
    <h1>Shippop Orders</h1>
    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="orders"
      class="elevation-1"
      :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
      :rows-per-page-text="$t('Rows per page')"
      v-bind:pagination.sync="paginate"
    >
      <template v-slot:items="props">
        <td>{{ props.item.timestamp | DateFormat('DD MMM YYYY HH:mm a') }}</td>
        <td>{{ props.item.purchase_group_id || '-' }}</td>
        <td>{{ props.item.purchase_id }}</td>
        <td>
          <v-chip small disabled color="blue" class="white--text">{{ props.item.status }}</v-chip>
        </td>

        <td>
          <v-btn
            v-if="props.item.status == 'confirm'"
            @click="
              selectItemGroupId(props.item.purchase_group_id)
              currentPaymentID = props.item.purchase_id
              showPreview = true
            "
            color="primary"
            depressed
          >
            Download <i v-if="props.item.printed_at" class="fas fa-check-circle  ml-2"></i>
          </v-btn>
          <v-btn
            v-else
            :loading="loading"
            @click="shippopConfirm(props.item)"
            color="grey"
            outline
            depressed
          >
            Reconfirm
          </v-btn>
        </td>

        <td>
          <v-btn
            @click="
              loadingExport = true
              allOrder = []
              exportAllOrder(props.item.purchase_group_id)
            "
            color="primary"
            outline
            :loading="loadingExport"
            depressed
          >
            Export <i v-if="props.item.exported_at" class="fas fa-check-circle  ml-2"></i>
          </v-btn>
        </td>

        <td>
          <v-tooltip top v-if="!loadShowOrder">
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                flat
                v-on="on"
                small
                color="grey"
                @click="
                  orderidlist = props.item.orderidlist ? props.item.orderidlist.split(',') : []
                  showDetailOrder(props.item.purchase_id)
                "
              >
                <v-icon>info</v-icon>
              </v-btn>
            </template>
            <span>
              <template>{{ $t('see_more') }}</template>
            </span>
          </v-tooltip>
          <v-progress-circular v-else indeterminate color="primary"></v-progress-circular>
        </td>
      </template>
    </v-data-table>
    <div style="height: 60px"></div>
    <preview-shippop-cover
      v-if="showPreview"
      v-model="showPreview"
      :currentGroupId="currentGroupId"
      :purchase_id="currentPaymentID"
    ></preview-shippop-cover>

    <v-dialog v-model="showOrder" max-width="800">
      <v-card v-if="dataOrdersDetail">
        <v-layout row wrap>
          <v-flex class="pt-4 pl-4 headline">Order No. ({{ dataOrdersDetail.length }})</v-flex>
          <v-flex shrink>
            <v-btn small flat fab @click="showOrder = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-text>
          <template>
            <v-data-table
              hide-actions
              :headers="headersDetail"
              :items="dataOrdersDetail"
              class="elevation-1"
            >
              <template v-slot:items="props">
                <td>{{ props.item.id }}</td>
                <td>{{ props.item.first_name }} {{ props.item.last_name }}</td>
                <td>{{ props.item.nameaddress }}</td>
                <td>{{ props.item.shippop_order_status }}</td>
                <td>{{ props.item.shippop_tracking_code }}</td>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import config from '@/config'
import { mapGetters } from 'vuex'
import api from '@/api'
import PreviewShippopCover from './PreviewShippopCover.vue'
export default {
  data() {
    return {
      loadingExport: false,
      allOrder: [],
      limit: 50,
      serverUrl: config.serverUrl,
      loading: true,
      orderidlist: null,
      orders: [],
      paginate: { sortBy: 'timestamp', descending: true, rowsPerPage: 10 },
      headersDetail: [
        { text: ' ID', sortable: false },
        { text: 'Social name', sortable: false },
        { text: 'Shipping address', sortable: false },
        { text: 'Status', sortable: false },
        { text: 'Tracking code', sortable: false }
      ],
      headers: [
        { value: 'timestamp', text: 'Time' },
        { value: 'purchase_group_id', text: 'Group id' },
        { value: 'purchase_id', text: 'Payment id' },
        { value: 'status', text: 'Status' },
        { text: 'Print Cover', sortable: false },
        { text: 'Export orders', sortable: false },
        { text: '', sortable: false }
      ],
      currentPaymentID: null,
      showPreview: false,
      showOrder: false,
      loadShowOrder: false,
      dataOrdersDetail: [],
      currentGroupId: []
    }
  },
  components: {
    PreviewShippopCover
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    })
  },
  async mounted() {
    this.loading = true
    try {
      var response = await this.shippopbookingrefno()
      if (response.responsecode == 200) {
        this.orders = response.data
      }
    } catch (error) {}
    this.loading = false
  },
  methods: {
    async selectItemGroupId(groupId) {
      const vm = this
      if (vm.orders && vm.orders.length > 0) {
        vm.currentGroupId = vm.orders.filter(item => item.purchase_group_id === groupId)
      }
    },
    async showDetailOrder(purchase_id) {
      this.loadShowOrder = true
      var res = await api.getShippopOrders({
        pageid: this.selectedBot.pageid,
        shippop_purchase_id: purchase_id
      })
      if (res.responsecode == 200) {
        this.dataOrdersDetail = res.data
        this.showOrder = true
      }
      this.loadShowOrder = false
    },

    async exportAllOrder(groupId) {
      const vm = this
      if (vm.orders && vm.orders.length > 0) {
        vm.currentGroupId = vm.orders.filter(item => item.purchase_group_id === groupId)
      }
      let result = await Promise.all(
        this.currentGroupId.map(item => vm.exportOrders(item.purchase_id, vm.limit, 0))
      )
      let allData = []
      result.forEach(item => {
        if (item.length > 0) {
          allData = allData.concat(item)
        }
      })
      allData.sort((a, b) => parseInt(b.id) - parseInt(a.id))
      if (vm.orders && vm.orders.length > 0) {
        vm.orders.map(item => {
          if (item.purchase_group_id === groupId) {
            item.exported_at = '00:00'
          }
        })
      }
      this.loadingExport = false
      return this.exportOrderData(allData, 'all')
    },

    async exportOrders(purchase_id, limit, offset) {
      const vm = this
      await vm.post(`shippop/${vm.selectedBot.pageid}/stamp-export-order`, {
        purchase_ids: [purchase_id]
      })

      vm.allOrder = []
      let response = await vm.getOrderSummary(purchase_id, limit, offset)
      if (response.responsecode == 200 && response.data) {
        vm.allOrder = response.data
        return vm.allOrder
      }
    },

    async getOrderSummary(purchase_id, limit, offset) {
      return new Promise((resolve, reject) => {
        api.getOrderSummary(
          {
            pageid: this.selectedBot.pageid,
            shippop_purchase_id: purchase_id
            // limit: limit,
            // offset: offset
          },
          (error, response) => {
            if (error) reject(error)
            resolve(response)
          }
        )
      })
      // this.exportOrderData()
    },
    async shippopConfirm(order) {
      this.loading = true
      if (order) {
        try {
          let response = await this.sendShippopConfirm(order.purchase_id)
          if (response.responsecode == 200) {
            var result = await this.$swal({
              title: 'ส่งข้อมูลไปที่ shippop สำเร็จ',
              text: 'หมายเลขการชำระเงินคือ ' + response.purchase_id,
              type: 'success',
              confirmButtonText: 'ปริ้นใบปะหน้า',
              showCancelButton: true,
              cancelButtonText: this.$t('cancel'),
              reverseButtons: true
            })
            let order_index = this.orders.findIndex(el => {
              return (el.purchase_id = response.purchase_id)
            })
            if (order_index != -1) {
              this.$set(this.orders[order_index], 'status', 'confirm')
            }

            this.currentPaymentID = response.purchase_id
            if (result.value) {
              this.showPreview = true
            } else {
              location.reload()
            }
          } else {
            throw new Error('shippop confirm unsuccessfully')
          }
        } catch (error) {
          let text = ''
          if (error.response && error.response.shippop_body) {
            if (error.response.shippop_body) {
              let body = error.response.shippop_body.data
              try {
                let parcel = body[Object.keys(body)[0]]
                parcel = parcel[Object.keys(parcel)[0]]
                if (parcel.remark) text = parcel.remark
                if (parcel.err_code) text = text + ` (${parcel.err_code})`
              } catch (error) {
                console.log(error)
              }
            }
          } else if (error.response && err.response.reason) {
            text = err.response.reason
          } else if (error.message) {
            text = error.message
          }
          await this.$swal({
            title: 'ส่งข้อมูลไม่สำเร็จ โปรดลองอีกครั้ง',
            text: text,
            type: 'error',
            confirmButtonText: this.$t('Confirm')
          })
        }
      }
      this.loading = false
    },
    sendShippopConfirm(purchase_id) {
      var vm = this
      return new Promise((resolve, reject) => {
        api.shippopconfirm(
          {
            params: { pageid: vm.selectedBot.pageid },
            body: {
              purchase_id: purchase_id
            }
          },
          async (error, response) => {
            if (error) {
              reject(error)
            }
            resolve(response)
          }
        )
      })
    },
    shippopbookingrefno() {
      var vm = this
      return new Promise((resolve, reject) => {
        api.shippopbookingrefno({ pageid: vm.selectedBot.pageid }, (error, response) => {
          if (error) {
            reject(error)
          }
          resolve(response)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/Shippop.vue